import {
  type IntegrationSecretQueries,
  defIntegrationSecretQueries,
} from '@kizen/query/integration-secrets';
import { useQueryClient } from '@tanstack/react-query';
import AxiosService from 'services/AxiosService';
import { useCallback } from 'react';

const queries: IntegrationSecretQueries =
  defIntegrationSecretQueries(AxiosService);

export const integrationSecretQuery: IntegrationSecretQueries['integrationSecretQuery'] =
  queries.integrationSecretQuery;

export const integrationSecretsQuery: IntegrationSecretQueries['integrationSecretsQuery'] =
  queries.integrationSecretsQuery;

export const integrationSecretsInfiniteQuery: IntegrationSecretQueries['integrationSecretsInfiniteQuery'] =
  queries.integrationSecretsInfiniteQuery;

export const useInvalidateIntegrationSecrets = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (id?: string) =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: integrationSecretsQuery().queryKey,
        }),
        queryClient.invalidateQueries({
          queryKey: integrationSecretsInfiniteQuery().queryKey,
        }),
        id
          ? queryClient.invalidateQueries({
              queryKey: integrationSecretQuery(id).queryKey,
            })
          : undefined,
      ]),
    [queryClient]
  );
};
